import { randomUUID } from '@/src/common/utils/randomUUID'
import AsyncStorage from '@react-native-async-storage/async-storage'

export const deviceIdPromise = (async () => {
  const cachedDeviceId = await AsyncStorage.getItem('deviceId')
  if (cachedDeviceId) return cachedDeviceId
  const newDeviceId = randomUUID()
  await AsyncStorage.setItem('deviceId', newDeviceId)
  return newDeviceId
})()

export type DeviceIdPromise = typeof deviceIdPromise
